document.addEventListener("DOMContentLoaded", function () {
	const blocks = document.querySelectorAll(".bloc-link");

	blocks.forEach((block) => {
		const titles = block.querySelectorAll(".onglet-titre");

		titles.forEach((title) => {
			title.addEventListener("click", function () {
				const id = this.id;
				const content = block.querySelector(`#${id}-contenu`);
				const mainContent = block.querySelector(`#${this.dataset.main}`);
				const isLinked = this.dataset.linked.toLowerCase() === "true";

				const allMainContent = block.querySelectorAll(
					".contents-content:not(#onglet-alone-content)",
				);

				allMainContent.forEach((mainContent) => {
					if (isLinked) mainContent.style.display = "none";
				});

				if (content.style.display === "none") {
					content.style.display = "block";
					if (isLinked) mainContent.style.display = "block";
					this.classList.add("open");
					this.classList.remove("close");
				} else {
					content.style.display = "none";
					if (isLinked) {
						mainContent.style.display = "none";
					}
					this.classList.remove("open");
					this.classList.add("close");
				}
			});
		});
	});
});

function isOneVisible() {
	const MainContents = document.querySelectorAll(
		".contents-content:not(#onglet-alone-content)",
	);
	let isOneVisible = false;

	MainContents.forEach((mainContent) => {
		if (mainContent.style.display === "block") isOneVisible = true;
	});

	return isOneVisible;
}
